












































































import LayoutFullWidth from "@/components/layouts/LayoutFullWidth.vue";
import FormInput from "@/components/FormInput.vue";
import FormInputError from "@/components/FormInputError.vue";
import FormValidation from "@/mixins/form-validation";
import { Login } from "@/types/login";
import url from "@/mixins/analytics/url";
import { Component, Mixins } from "vue-property-decorator";

@Component({
  components: {
    LayoutFullWidth,
    FormInput,
    FormInputError,
  },
})
export default class LoginView extends Mixins(url, FormValidation) {
  login: Login = {
    username: "",
    password: "",
  };

  title = "Sign in";
  loggingIn = false;

  usernameError = "";
  passwordError = "";

  loginUser() {
    this.usernameError = this.validateString(this.login.username);
    if (this.usernameError) return;

    this.passwordError = this.validateString(this.login.password);
    if (this.passwordError) return;

    this.$ga.button("Sign in user");

    this.title = "Signing in";
    this.loggingIn = true;

    this.$store.dispatch("login", this.login).then((cacheId: number) => {
      this.title = "Sign in";
      this.loggingIn = false;

      if (cacheId) {
        this.$router.push({
          name: "overview",
          params: { cacheId: cacheId.toString() },
        });
      }
    });
  }
}
